<script type="text/javascript">
var commonMixin = {
  created: function () {    
  },
  methods: {
    downloadImageFromURL: function (url, name) {
      fetch(url)
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = name;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch(() => console.log('An error sorry', name));
    },
    	getCDNUrl(path) {
			if (path && path.includes('firebasestorage.googleapis.com')) {
				path = path.replace('https://firebasestorage.googleapis.com/v0/b/', 'https://resources.e2m.live/');
				path = path.replace('/o/', '/');
				return path;
			} else {
				return path;
			}
		},
  }
}
export default commonMixin
</script>